import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CommonStatCard from "../pt/pt-flow-new/CommonStatCard";
import { getCardLabel } from "./recurring-labels/RecurringSubscriptionLables";
import { getCardIcon } from "../common-data/Conversions";
import "../../styles/plans/recurring-999.css";

const STAT_ORDER = [
  "total",
  "total_pending",
  "total_completed",
  "total_added_to_lead",
  "total_not_added_to_lead",
];

const EXCLUDED_KEYS = [""];

const RecurringSubsStats = ({ isFromODM, isTbData }) => {
  const {
    recurringSubscriptionStatsLoading,
    recurringSubscriptionStatsError,
    recurringSubscriptionStats,
  } = useSelector((state) => state.plans);

  const iniDatas = {
    allStats: {},
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  useEffect(() => {
    if (
      !recurringSubscriptionStatsLoading &&
      !recurringSubscriptionStatsError &&
      recurringSubscriptionStats?.status &&
      recurringSubscriptionStats?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allStats: recurringSubscriptionStats.data,
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [
    recurringSubscriptionStatsLoading,
    recurringSubscriptionStatsError,
    recurringSubscriptionStats,
  ]);

  const sortedCards =
    allDatas.allStats &&
    Object?.entries(allDatas.allStats)
      ?.sort(([keyA], [keyB]) => {
        const indexA = STAT_ORDER.indexOf(keyA);
        const indexB = STAT_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => (
        <React.Fragment key={index}>
          {!EXCLUDED_KEYS.includes(key) && (
            <CommonStatCard
              tagName={key}
              cardLabel={getCardLabel(key)}
              value={value}
              icon={
                isFromODM
                  ? null
                  : getCardIcon(
                      key,
                      recurringSubscriptionStatsLoading,
                      "recurring_999"
                    )
              }
            />
          )}
        </React.Fragment>
      ));

  return (
    <div
      className="cards-container cards-grid-container grid-5 pt-flow-new recurring-999"
      style={{ marginTop: isTbData ? "0" : "" }}>
      {sortedCards}
    </div>
  );
};

export default RecurringSubsStats;
